import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as React from 'react';
import { LocalizeContextProps, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { DropdownItem } from 'reactstrap';
import { Dispatch } from 'redux';
import { hasPrivilege } from '../../../stores/auth/selectors';
import { RootState } from '../../../stores/store';
import { selected } from '../../../stores/tables/selectors';
import { synchronizeUsers } from '../../../stores/applications/actionCreators';
import ConfirmModal from '../../common/modals/ConfirmModal';

interface Props extends LocalizeContextProps {
    hasPrivilege: (privileges: string[]) => boolean;
    selected: string[];

    synchronizeUsers: (ids: string[]) => void;
}
interface State {
    showModal: boolean;
}

class SynchronizeUsersAction extends React.Component<Props, State> {
    public constructor(props: Props) {
        super(props);
        this.state = {
            showModal: false,
        };
    }

    public render() {
        const t = this.props.translate;
        if (this.props.hasPrivilege(['SUPER_ADMIN'])) {
            return (
                <React.Fragment>
                    <DropdownItem
                        onClick={() => {
                            this.setState({ showModal: true });
                        }}
                    >
                        <FontAwesomeIcon icon={['fal', 'sync']} />
                        {t('applications.button.synchronize')}
                    </DropdownItem>
                    <ConfirmModal
                        header={t('applications.modal.synchronize.header') as string}
                        confirmText={t('applications.modal.synchronize.synchronize') as string}
                        isOpen={this.state.showModal}
                        confirm={() => {
                            this.props.synchronizeUsers(this.props.selected);
                        }}
                        cancel={() => { this.setState({ showModal: false }); }}
                    >
                        {t('applications.modal.synchronize.text') as string}
                    </ConfirmModal>
                </React.Fragment>
            );
        } else {
            return null;
        }
    }
}

const mapStateToProps = (state: RootState) => ({
    hasPrivilege: hasPrivilege(state),
    selected: selected(state, 'applications'),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    synchronizeUsers: (ids: string[]) => dispatch(synchronizeUsers(ids)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withLocalize(SynchronizeUsersAction));